import {FC} from 'react';
import ApiServiceContext from './context';
import {IApiService} from '../../api/IApiService';
import {mockApiService} from '../../api/MockApiService';
import {useSettingsContext} from '../settings/useSettingsContext';
import {createApiService} from '../../api/ApiService';

type Props = {
    useMock?: boolean,
    children?: React.ReactNode;
}

const ApiServiceContextProvider: FC<Props> = ({ useMock = false, children }) => {
    const settings = useSettingsContext();
    const service: IApiService = useMock
        ? mockApiService
        : createApiService(
            settings.tokenUrl,
            settings.apiUrl,
            settings.companyInfoId,
            settings.useGoogleRecaptchaV3,
            settings.recaptchaUrl,
        )
    ;

    return (
        <ApiServiceContext.Provider value={service}>
            {children}
        </ApiServiceContext.Provider>
    );
};

export default ApiServiceContextProvider;
